var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      staticClass: "card-preview-modal",
      attrs: { id: "card-preview-modal" },
      on: { shown: _vm.setup, hidden: _vm.clean }
    },
    [
      _c(
        "div",
        {
          staticClass: "w-100",
          attrs: { slot: "modal-header" },
          slot: "modal-header"
        },
        [
          _c("h5", { staticClass: "modal-title card-preview-modal__title" }, [
            _vm._v(_vm._s(_vm.cardTitle))
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "modal-close",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.$root.$emit("hide::modal", "card-preview-modal")
                }
              }
            },
            [_c("img", { attrs: { src: "/static/images/btn-close.svg" } })]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-6" }, [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showToggle,
                      expression: "showToggle"
                    }
                  ]
                },
                [
                  _c(
                    "ToggleSwitch",
                    {
                      attrs: {
                        "model-value": _vm.showSolution,
                        "check-value": true,
                        id: "show-solution-switch"
                      },
                      on: { change: _vm.toggleShowSolution }
                    },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(
                          _vm._s(_vm.$t("common.modal.preview.show_solution"))
                        )
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "divider" }),
              _vm._v(" "),
              _vm.isStorePage
                ? _c(
                    "span",
                    {
                      staticClass:
                        "typography--body-3 typography--color-secondary typography--font-weight-500 passive-link-btns clickable",
                      on: {
                        click: function($event) {
                          return _vm.showReportContentModal()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("common.modal.preview.report_content")
                          ) +
                          "\n        "
                      )
                    ]
                  )
                : _vm._e()
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _vm.hasAudio(_vm.currentPage)
        ? _c("LcAudio", {
            attrs: { audio: _vm.getFormattedAudio(_vm.currentPage) }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.hasNoPages
        ? _c("div", {
            staticClass:
              "typography--body-2 typography--color-disabled text-center mt-5",
            domProps: {
              innerHTML: _vm._s(_vm.$t("common.modal.preview.no_pages"))
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.onShown
        ? _c(
            "div",
            {
              staticClass: "preview-content-container",
              class: { "show-solution": _vm.showSolution }
            },
            [
              _vm.isQuizPage
                ? _c("div", { staticClass: "quiz-badge" }, [
                    _c("span", { staticClass: "badge badge-default" }, [
                      _vm._v(_vm._s(_vm.$t("common.card.quiz")))
                    ]),
                    _vm._v(" "),
                    _vm.isClassAssignmentPreview
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "typography--body-3 typography--color-secondary ml-1"
                          },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(
                                  _vm.$t(
                                    "common.modal.preview.class_average_score"
                                  )
                                ) +
                                ": " +
                                _vm._s(
                                  _vm.getAverageQuizScoreRatio(
                                    _vm.currentPage.submitted_answers
                                  )
                                ) +
                                "%\n      "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass:
                          "typography--body-1 typography--color-secondary float-right"
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("common.numeric_score", {
                              n: _vm.currentPage.score || 1
                            })
                          )
                        )
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.hasExtraContent
                ? _c("div", { staticClass: "preview-content" }, [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.currentPage.extra_content.title) +
                        "\n      "
                    ),
                    _c("div", [
                      _c("img", {
                        staticClass: "extra-content-image",
                        attrs: { src: _vm.currentPage.extra_content.image_url }
                      })
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.hasVideo(_vm.currentPage)
                ? _c("LcVideo", {
                    attrs: { video: _vm.getFormattedVideo(_vm.currentPage) }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.currentPage
                ? _c("div", {
                    staticClass: "preview-content",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.parseHyperlink(_vm.currentPage.content)
                      )
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.getPageType() === "multiple_choice" &&
              _vm.isVisibleQuizOptions()
                ? _c(
                    "div",
                    { staticClass: "quiz-answers" },
                    _vm._l(_vm.quizAnswers, function(answer, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "typography--content-body" },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(index + 1) +
                              ". " +
                              _vm._s(_vm.getAnswerContent(answer)) +
                              "\n      "
                          )
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isQuizPage && _vm.showSolution && !_vm.isEssayType
                ? _c("div", { staticClass: "quiz-answer-result-container" }, [
                    _vm.isStudentAssignmentPreview && _vm.submittedAnswer
                      ? _c(
                          "div",
                          {
                            staticClass: "typography--content-body is-incorrect"
                          },
                          [
                            _vm.submittedAnswer &&
                            _vm.submittedAnswer.is_correct
                              ? _c("strong", [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(
                                        _vm.$t(
                                          "common.modal.preview.is_correct"
                                        )
                                      ) +
                                      "\n        "
                                  )
                                ])
                              : _c("strong", [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(
                                        _vm.$t(
                                          "common.modal.preview.is_incorrect"
                                        )
                                      ) +
                                      "\n        "
                                  )
                                ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "quiz-answer-result" }, [
                      _c("span", { staticClass: "typography--body-1" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("common.modal.preview.correct_answer")
                            ) +
                            ":\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _vm.getPageType() === "multiple_choice"
                        ? _c("span", { staticClass: "typography--body-1" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$t("common.modal.preview.answer_number", {
                                    n: _vm.correctAnswerIndex
                                  })
                                ) +
                                "\n        "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.getPageType() === "text_entry"
                        ? _c("span", { staticClass: "typography--body-1" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.correctAnswerContents) +
                                "\n        "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isStudentAssignmentPreview
                        ? _c("span", { staticClass: "incorrect-answer-area" }, [
                            _c(
                              "span",
                              { staticClass: "typography--color-dividers" },
                              [_vm._v("|")]
                            ),
                            _vm._v(" "),
                            _vm.getPageType() === "multiple_choice"
                              ? _c(
                                  "span",
                                  { staticClass: "typography--body-1" },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.$t(
                                            "common.modal.preview.chosen_answer"
                                          )
                                        ) +
                                        ":\n            "
                                    ),
                                    _vm.submittedAnswer
                                      ? _c("span", [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.$t(
                                                  "common.modal.preview.answer_number",
                                                  {
                                                    n: _vm.submittedAnswerIndex
                                                  }
                                                )
                                              ) +
                                              "\n            "
                                          )
                                        ])
                                      : _c("span", [_vm._v("-")])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.getPageType() === "text_entry"
                              ? _c(
                                  "span",
                                  { staticClass: "typography--body-1" },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.$t(
                                            "common.modal.preview.entered_answer"
                                          )
                                        ) +
                                        ":\n            "
                                    ),
                                    _vm.submittedAnswer
                                      ? _c("span", [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.submittedAnswerContent
                                              ) +
                                              "\n            "
                                          )
                                        ])
                                      : _c("span", [_vm._v("-")])
                                  ]
                                )
                              : _vm._e()
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _vm.isStudentAssignmentPreview &&
                    _vm.submittedAnswer &&
                    !_vm.submittedAnswer.is_correct
                      ? _c("div", { staticClass: "incorrect-img" }, [
                          _c("img", {
                            attrs: { src: "/static/images/quiz-wrong-s.svg" }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isStudentAssignmentPreview &&
                    _vm.submittedAnswer &&
                    _vm.submittedAnswer.is_correct
                      ? _c("div", { staticClass: "correct-img" }, [
                          _c("img", {
                            attrs: { src: "/static/images/quiz-correct-s.png" }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isClassAssignmentPreview &&
                    _vm.currentPage.submitted_answers &&
                    _vm.currentPage.submitted_answers.length > 0
                      ? _c(
                          "div",
                          { staticClass: "class-quiz-answer-results" },
                          [
                            _vm.getPageType() === "multiple_choice"
                              ? _c(
                                  "div",
                                  _vm._l(_vm.quizAnswers, function(
                                    answer,
                                    index
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass:
                                          "typography--body-1 typography--color-secondary"
                                      },
                                      [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(index + 1) +
                                            ".\n            " +
                                            _vm._s(
                                              _vm.getSumittedAnswerCount(answer)
                                            ) +
                                            _vm._s(
                                              _vm.$t(
                                                "common.modal.preview.count"
                                              )
                                            ) +
                                            "\n            (" +
                                            _vm._s(
                                              _vm.getSumittedAnswerRatio(
                                                _vm.getSumittedAnswerCount(
                                                  answer
                                                )
                                              )
                                            ) +
                                            "%)\n          "
                                        )
                                      ]
                                    )
                                  }),
                                  0
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.getPageType() === "text_entry"
                              ? _c(
                                  "div",
                                  _vm._l(
                                    _vm.summarizedSubmittedAnswers,
                                    function(value, key) {
                                      return _c(
                                        "div",
                                        {
                                          key: key,
                                          staticClass:
                                            "typography--body-1 typography--color-secondary"
                                        },
                                        [
                                          _vm._v(
                                            "\n            " +
                                              _vm._s(key) +
                                              " -\n            " +
                                              _vm._s(value.length) +
                                              _vm._s(
                                                _vm.$t(
                                                  "common.modal.preview.count"
                                                )
                                              ) +
                                              "\n            (" +
                                              _vm._s(
                                                _vm.getSumittedAnswerRatio(
                                                  value.length
                                                )
                                              ) +
                                              "%)\n          "
                                          )
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _vm._e()
                          ]
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isQuizPage && _vm.showSolution
                ? _c("div", { staticClass: "quiz-description" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "typography--content-body description-header"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.$t("common.card.page.description")))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm.currentPage &&
                    !_vm.isEssayType &&
                    _vm.currentPage.description
                      ? _c("div", {
                          staticClass: "preview-content",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.parseHyperlink(_vm.currentPage.description)
                            )
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.currentPage &&
                    _vm.isEssayType &&
                    _vm.currentPage.description
                      ? _c("div", {
                          staticClass: "preview-content",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.parseHyperlink(
                                _vm.currentPage.description
                                  .replace(/\n/g, "<br>")
                                  .replace(/\\n/g, "<br>")
                              )
                            )
                          }
                        })
                      : _vm._e()
                  ])
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "row",
          attrs: { slot: "modal-footer" },
          slot: "modal-footer"
        },
        [
          _c("div", { staticClass: "col-5 hidden-sm-up" }, [
            !_vm.isPagePreview
              ? _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-outline-primary btn-fab btn-mini-fab mr-1",
                    attrs: {
                      type: "button",
                      disabled: _vm.currentPageIndex === 0
                    },
                    on: { click: _vm.prev }
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("arrow_back")
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.isPagePreview
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-primary btn-fab btn-mini-fab",
                    attrs: { type: "button", disabled: _vm.isLastPage },
                    on: { click: _vm.next }
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("arrow_forward")
                    ])
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-5 hidden-xs-down" }, [
            !_vm.isPagePreview
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-primary mr-1",
                    attrs: {
                      type: "button",
                      disabled: _vm.currentPageIndex === 0
                    },
                    on: { click: _vm.prev }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("common.previous")) +
                        "\n      "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.isPagePreview
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-primary",
                    attrs: { type: "button", disabled: _vm.isLastPage },
                    on: { click: _vm.next }
                  },
                  [
                    _vm._v(
                      "\n        " + _vm._s(_vm.$t("common.next")) + "\n      "
                    )
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-2 text-center page-counter" }, [
            !_vm.isPagePreview
              ? _c(
                  "small",
                  {
                    staticClass:
                      "typography--body-3 typography--color-secondary"
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.currentPageIndex + 1) +
                        "/" +
                        _vm._s(_vm.cardPagesLength) +
                        "\n      "
                    )
                  ]
                )
              : _vm._e()
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d558bed0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d558bed0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardPreview.vue
// module id = pgxr
// module chunks = 1